<template>
  <div class="lecture-notes-box">
    <div class="lecture-group" @click="lectureNotes" style="cursor: pointer">
      <div class="lecture-group-2">
        <svg
            class="lecture-path"
            width="20"
            height="36"
            viewBox="0 0 20 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M1.96149 35.3867C4.58015 35.4289 6.7524 33.5132 8.83678 31.9244C11.5477 29.8587 14.5399 28.191 17.7226 26.9718C18.1937 26.7926 18.7068 26.5922 18.9705 26.1634C19.158 25.7884 19.236 25.3681 19.1954 24.9507C19.1573 18.3695 18.5694 11.8029 17.4379 5.31959C17.0864 3.39689 16.6365 1.3336 15.1567 0.0646973L2.08451 6.50765C1.63542 6.67413 1.25204 6.98108 0.991356 7.38288C0.834131 7.82142 0.816936 8.29796 0.942147 8.74669C2.26009 16.4327 2.60845 24.2537 1.97906 32.0264"
              fill="#232323"
          />
        </svg>

        <svg
            class="lecture-path-2"
            width="23"
            height="39"
            viewBox="0 0 23 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M2.95956 38.7013C7.06154 38.7716 10.0493 35.4675 13.3393 33.5062C15.0672 32.4688 16.8819 31.5832 18.7629 30.8594C19.6768 30.5079 20.6118 30.2337 21.255 29.4534C21.9791 28.5676 22.0178 27.5307 22.0213 26.434C22.0092 21.7587 21.6922 17.0891 21.0722 12.455C20.5872 8.6131 20.4852 3.61832 17.4237 0.806336C16.8415 0.259754 15.9745 0.147839 15.2725 0.528653L5.47277 5.37581C4.06678 6.0788 2.23196 6.6412 1.08959 7.73787C-0.217979 8.99623 0.165153 10.6307 0.421746 12.2406C1.53049 19.4495 1.7959 26.7631 1.21262 34.0334C1.03687 36.3146 4.57996 36.2971 4.76274 34.0334C5.29137 27.4728 5.12288 20.8746 4.2601 14.3495C4.16168 13.5926 4.05506 12.8369 3.94024 12.0824C3.87345 11.643 3.46572 10.5745 3.65904 10.2019C3.85236 9.82928 5.45168 9.31258 5.84887 9.11926L7.95786 8.08585L17.0722 3.59723L14.921 3.31954C16.0388 4.37404 16.327 5.95929 16.6012 7.42504C16.9527 9.25985 17.2163 11.1158 17.4483 12.9682C17.958 17.0069 18.2286 21.0526 18.3411 25.1335C18.3411 25.5658 18.3622 25.9982 18.3727 26.4305C18.3727 26.673 18.1794 27.5202 18.5204 27.1019C18.0915 27.6256 16.7629 27.8717 16.1267 28.1564C14.5142 28.9051 12.9618 29.777 11.4834 30.7645C10.0774 31.7135 8.75927 32.7961 7.42358 33.8541C6.08789 34.9122 4.69947 35.9631 2.9701 36.0616C1.24074 36.16 1.26183 38.6661 2.9701 38.6943L2.95956 38.7013Z"
              fill="#232323"
          />
        </svg>

        <svg
            class="lecture-path-3"
            width="79"
            height="39"
            viewBox="0 0 79 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M0.177734 11.5477C10.6207 7.28406 21.2254 3.20669 32.3398 1.19612C37.1166 0.331436 42.0411 -0.139571 46.8215 0.718084C51.6018 1.57574 56.2557 3.88156 59.1872 7.74804C60.9939 10.1347 62.0694 12.9818 63.5739 15.5689C67.0361 21.5443 72.6214 25.9029 78.0731 30.1279C64.3114 28.5243 50.3653 29.9876 37.2361 34.4127C30.2905 36.7607 23.1024 39.9769 15.9213 38.5006C11.1183 37.4832 6.97547 34.4691 4.52928 30.2123"
              fill="#F3D8D9"
          />
        </svg>

        <svg
            class="lecture-path-4"
            width="81"
            height="43"
            viewBox="0 0 81 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M1.4949 14.6901C7.36842 12.4334 13.3439 10.3315 19.3545 8.46504C25.3651 6.59858 31.4636 4.91842 37.7062 4.24706C43.5059 3.61788 49.629 3.97641 54.7046 7.13637C56.8874 8.49687 58.6989 10.3772 59.9771 12.6092C61.4674 15.1646 62.5746 17.9133 64.2618 20.3597C67.8612 25.583 72.8524 29.5408 77.8156 33.3968L79.0704 30.3704C68.8176 29.1947 58.4415 29.7041 48.3531 31.8783C43.2774 32.9679 38.3811 34.5637 33.4882 36.2755C28.6797 37.9557 23.5373 39.7061 18.3738 38.9891C13.6481 38.2792 9.50568 35.4493 7.12589 31.3054C5.94134 29.2667 2.77084 31.112 3.96241 33.1542C6.22489 37.0101 9.75384 39.9627 13.9485 41.5093C18.8413 43.3301 24.1981 42.6868 29.1121 41.309C34.367 39.8327 39.3899 37.671 44.6729 36.2826C49.9136 34.9107 55.2656 34.0061 60.666 33.5795C66.8037 33.1059 72.9728 33.2236 79.088 33.931C80.5467 34.0962 81.5239 31.8221 80.3393 30.9046C75.7699 27.3616 70.9614 23.7306 67.5589 18.9713C65.7381 16.43 64.5747 13.5512 62.9894 10.8693C61.6081 8.49699 59.7391 6.44475 57.5061 4.84812C52.6484 1.36478 46.4409 0.32435 40.585 0.630153C33.9979 0.981651 27.4389 2.58799 21.1542 4.49663C14.0855 6.65131 7.37546 9.62146 0.602095 12.5424C-0.617601 13.0697 0.250598 15.1892 1.51599 14.7076L1.4949 14.6901Z"
              fill="#232323"
          />
        </svg>

        <svg
            class="lecture-path-5"
            width="115"
            height="67"
            viewBox="0 0 115 67"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M114.703 27.0541C114.158 23.3599 113.603 19.627 112.222 16.1577C108.45 6.66726 98.1336 0.234854 87.9683 1.00815C79.0824 1.68302 73.4725 9.49682 67.4935 15.2614C60.0418 22.4495 52.4459 29.5919 43.6936 35.1948C34.8148 40.875 24.3367 45.086 13.384 45.5148C7.80221 45.7327 6.28374 45.4164 4.69497 50.6888C3.15893 55.7926 1.74942 60.8998 0.726562 66.1161C19.6231 66.6855 38.0064 65.5712 56.917 65.0229C73.4163 64.5413 90.5869 64.5624 106.868 61.9719C109.1 57.2935 113.487 43.5956 114.415 37.1421"
              fill="white"
          />
        </svg>

        <svg
            class="lecture-path-6"
            width="118"
            height="69"
            viewBox="0 0 118 69"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M117.015 28.0541C116.382 22.3845 115.539 16.7465 112.256 11.9239C109.471 7.83556 105.599 4.60593 101.078 2.59868C96.6351 0.630294 91.5876 -0.251965 86.7791 0.658414C82.0444 1.55122 78.0479 4.50028 74.6208 7.74109C70.8141 11.3334 67.278 15.2034 63.4783 18.8062C59.0565 22.9926 54.5187 27.0945 49.6434 30.7572C40.1811 37.8574 29.1511 43.4673 17.2248 44.6026C13.3583 44.9752 7.92414 43.9348 5.46365 47.7661C3.94167 50.1352 3.39685 53.2671 2.65167 55.9314C1.66045 59.478 0.77116 63.0492 0.0541051 66.6626C-0.0779545 67.1826 0.0346608 67.7343 0.359902 68.1609C0.685142 68.5875 1.18739 68.8422 1.72372 68.8525C21.6571 69.4324 41.5765 68.1495 61.4783 67.6468C71.1445 67.4008 80.8107 67.2532 90.4663 66.5923C95.2502 66.2654 100.02 65.805 104.769 65.1547C105.89 65.0036 107.229 65.0001 108.308 64.6345C109.12 64.3568 109.412 63.7065 109.714 62.9825C110.245 61.7698 110.73 60.5395 111.191 59.3023C113.651 52.6414 115.964 45.6431 117.011 38.5956C117.145 37.6852 116.783 36.7924 115.83 36.5182C115.036 36.2897 113.887 36.7959 113.753 37.6992C113.106 42.0683 111.788 46.3777 110.488 50.5886C109.293 54.4551 108.08 58.4306 106.347 62.1037L107.377 61.3128C93.9004 63.4218 80.2237 63.7733 66.6031 64.0862C52.828 64.4166 39.0633 65.0704 25.2916 65.3937C17.4216 65.5765 9.55157 65.6222 1.68505 65.3937L3.35467 67.5836C3.95573 64.5607 4.67278 61.5624 5.46365 58.5887C6.16665 55.9279 6.77474 53.0702 7.87141 50.5359C8.39866 49.3127 8.89076 48.7784 10.0331 48.5359C11.7906 48.1563 13.7203 48.3074 15.5165 48.1844C26.7257 47.4322 37.4078 42.9963 46.6908 36.824C55.9176 30.6833 64.2938 22.9539 71.9986 15.0101C75.1621 11.7341 78.2834 8.22616 82.2483 5.87112C86.2132 3.51609 90.744 3.09429 95.194 4.09255C100.234 5.24242 104.773 7.9787 108.143 11.8993C112.147 16.5496 113.321 22.5286 114.403 28.3951C114.667 29.8292 117.141 29.5199 116.976 28.0436L117.015 28.0541Z"
              fill="#232323"
          />
        </svg>

        <svg
            class="lecture-path-7"
            width="152"
            height="66"
            viewBox="0 0 152 66"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M0.177734 19.7676C4.63824 5.63384 44.245 -4.62287 64.8322 2.35085C82.4879 8.32631 96.9134 22.9135 115.353 25.6587C118.671 26.1508 121.557 27.5989 125.037 27.736C129.279 27.9047 133.508 27.2052 137.743 27.1349C138.015 27.1066 138.29 27.1566 138.534 27.2791C138.787 27.4882 138.962 27.7769 139.03 28.0981C141.691 36.2036 144.337 44.9875 148.362 52.5377C148.805 53.3742 151.308 55.8558 151.301 56.5658C151.276 58.1652 148.348 59.1177 147.037 59.7082C143.216 61.4376 139.072 62.3691 134.956 63.0721C120.952 65.4658 106.66 65.3779 92.4564 65.2795"
              fill="#F3D8D9"
          />
        </svg>

        <svg
            class="lecture-path-8"
            width="156"
            height="70"
            viewBox="0 0 156 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M3.35531 22.0909C4.82106 17.873 9.08824 14.9942 12.793 12.9028C18.2623 9.82014 24.3046 7.7674 30.3855 6.28759C42.8636 3.24714 56.797 2.09774 68.9834 6.87459C84.4493 12.9309 97.1771 24.8959 113.592 28.6674C115.701 29.1525 117.87 29.4056 119.968 29.9856C122.067 30.5655 124.147 31.2017 126.334 31.3916C128.759 31.6095 131.227 31.3916 133.645 31.2158C134.833 31.1244 136.018 31.026 137.202 30.9557C137.882 30.9629 138.561 30.9312 139.237 30.8608C139.402 30.8327 140.032 30.9944 139.554 30.6991C139.076 30.4038 139.575 31.1947 139.659 31.4513C141.139 36.0032 142.577 40.5727 144.267 45.0508C145.093 47.2441 145.965 49.4199 146.928 51.557C147.729 53.3426 148.499 55.1563 149.74 56.6853C150.193 57.2477 150.686 57.7785 151.118 58.3585C151.216 58.485 151.41 58.9138 151.526 58.9595C151.642 59.0052 151.589 58.6853 151.48 58.5588C151.266 58.3092 151.761 58.4288 151.364 58.4955C150.889 58.5729 150.099 59.2513 149.606 59.4622C148.812 59.8137 148.007 60.1652 147.199 60.4815C142.707 62.2917 137.849 63.1212 133.076 63.8032C122.815 65.2689 112.425 65.4165 102.08 65.4482C99.5356 65.4482 96.9908 65.4482 94.4459 65.4482C92.0839 65.4482 92.0839 69.0897 94.4459 69.1143C105.318 69.2303 116.214 69.2935 127.047 68.2391C132.274 67.7329 137.547 67.0545 142.65 65.8032C145.153 65.1784 147.599 64.3436 149.961 63.3075C151.389 62.6924 152.935 62.1335 154.042 60.9947C156.928 58.028 152.988 55.68 151.677 53.2125C149.301 48.7696 147.508 44.0455 145.874 39.2897C145.03 36.8292 144.229 34.3687 143.413 31.9083C142.735 29.8239 142.359 27.4864 139.722 27.4161C134.506 27.279 129.251 28.8221 124.077 27.5884C121.828 27.0541 119.652 26.33 117.364 25.9609C115.223 25.6148 113.11 25.1227 111.037 24.4881C106.922 23.1664 102.939 21.4624 99.1419 19.3985C91.3317 15.293 83.9994 10.3228 76.0626 6.44577C72.5054 4.68828 68.8007 3.08896 64.9588 2.08368C61.8326 1.29525 58.6382 0.80796 55.4191 0.628481C48.3119 0.164504 41.1202 0.842895 34.143 2.20319C27.4083 3.51428 20.6771 5.52836 14.5259 8.60748C9.88965 10.9274 5.03547 14.003 2.28676 18.5478C1.73992 19.4544 1.30666 20.4248 0.996761 21.4371C0.532784 22.9521 2.84212 23.5461 3.35531 22.0839V22.0909Z"
              fill="#232323"
          />
        </svg>

        <svg
            class="lecture-path-9"
            width="123"
            height="41"
            viewBox="0 0 123 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M0.636719 17.6567C10.6439 13.1892 29.681 4.33497 40.3876 2.02212C51.0942 -0.290737 62.5741 -0.357522 72.7254 3.77961C81.6112 7.42464 89.8679 13.5899 99.3583 15.7903C106.873 17.5478 114.68 15.3017 122.072 13.0873C122.322 18.2156 117.956 22.2824 113.784 25.2737C104.757 31.7448 94.8029 36.9645 84.1736 40.2123"
              fill="#F3D8D9"
          />
        </svg>

        <svg
            class="lecture-path-10"
            width="125"
            height="44"
            viewBox="0 0 125 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M2.19251 19.6058C8.63898 16.7692 15.0573 13.8764 21.5741 11.212C27.9889 8.58632 34.5479 5.91142 41.3318 4.40701C50.1614 2.44917 59.6097 2.1258 68.376 4.55816C77.0439 6.9624 84.4184 12.3966 92.6293 15.901C97.3078 17.8975 102.151 19.2648 107.283 19.0645C112.84 18.8501 118.232 17.307 123.526 15.7252L121.375 14.0837C121.463 17.6866 119.076 20.4951 116.496 22.7411C113.593 25.2684 110.236 27.3563 106.956 29.3563C99.9853 33.6364 92.5074 37.03 84.696 39.4584C82.4781 40.1367 83.4271 43.6377 85.6556 42.9417C94.2133 40.2543 102.381 36.4537 109.948 31.6375C116.106 27.7465 125.002 22.4353 124.774 14.0627C124.767 13.5346 124.518 13.0389 124.098 12.7189C123.678 12.399 123.133 12.2904 122.623 12.4247C117.941 13.8307 113.181 15.2753 108.282 15.6303C103.543 15.9818 99.1109 14.9871 94.7243 13.2507C86.4535 9.97474 79.1037 4.62494 70.5377 2.04495C61.6729 -0.622916 52.1579 -0.461227 43.1209 1.27166C36.1542 2.60383 29.4898 5.25412 22.9625 7.96769C15.5811 11.0327 8.34021 14.386 1.06772 17.6796C-0.229304 18.2666 0.895488 20.14 2.17845 19.5812L2.19251 19.6058Z"
              fill="#232323"
          />
        </svg>

        <svg
            class="lecture-path-11"
            width="117"
            height="60"
            viewBox="0 0 117 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M0.394531 24.8556C1.88488 -1.36617 20.2858 0.64088 28.5143 0.507311C40.5602 0.306957 49.4038 8.20159 55.9944 13.1401C71.2494 24.5744 79.9525 32.4936 100.23 32.6764C102.062 32.694 104.097 32.6975 105.429 33.9523C106.255 34.7291 106.645 35.8539 106.979 36.94C109.331 44.5254 110.846 53.0246 116.821 58.2513C116.118 57.6362 111.679 58.4306 110.652 58.4658C108.393 58.5478 106.131 58.6251 103.865 58.6977C99.1291 58.8524 94.3944 58.9895 89.6609 59.109C80.4024 59.334 71.1369 59.4605 61.8926 59.3621C52.6482 59.2637 43.4003 58.9649 34.177 58.3427C25.7832 57.7768 18.0362 58.5185 9.62134 59C8.9004 59.0869 8.16941 59.0307 7.47018 58.8348C6.06419 58.3357 5.33659 56.8418 4.74256 55.4851C2.91477 51.3057 2.22583 35.5411 0.394531 31.3618"
              fill="white"
          />
        </svg>

        <svg
            class="lecture-group-3"
            width="240"
            height="63"
            viewBox="0 0 240 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M94.5882 25.8556C95.133 17.3739 97.9063 8.12952 106.479 4.69188C109.274 3.5706 112.279 3.13474 115.267 3.00117C118.385 2.86058 121.699 2.76567 124.796 3.11717C130.771 3.79204 136.156 6.67784 140.993 10.0874C145.608 13.3422 149.998 16.9381 154.497 20.3476C158.842 23.6341 163.25 26.8925 168.072 29.4549C172.855 32.0145 178.025 33.7719 183.377 34.6571C186.905 35.1758 190.464 35.4565 194.03 35.4971C195.704 35.5428 197.176 35.708 197.897 37.4339C198.54 38.998 198.909 40.7169 199.37 42.3549C201.233 48.9314 203.257 55.8735 208.509 60.5976L210.797 57.6274C209.64 56.8541 207.872 57.1283 206.579 57.2584C204.99 57.4165 203.451 57.5782 201.851 57.6309C196.342 57.8067 190.835 57.9672 185.331 58.1125C174.304 58.3902 163.274 58.5308 152.244 58.3585C146.646 58.2718 141.048 58.0949 135.45 57.8278C129.956 57.5571 124.476 57.0615 118.968 57.1424C113.696 57.2232 108.423 57.638 103.151 57.9367C102.29 57.9895 101.302 58.225 100.645 57.5395C100.147 56.933 99.7689 56.2376 99.5303 55.4903C99.154 54.3708 98.8764 53.2206 98.7007 52.0527C98.0258 48.3584 97.6462 44.615 97.1366 40.8961C96.8905 39.1386 96.6374 37.3812 96.2508 35.6237C96.0891 34.9207 95.9239 34.1825 95.7165 33.476C95.6392 33.2124 95.5583 32.9523 95.4669 32.6922C95.4107 32.5305 94.9924 31.5252 95.1436 31.8908C94.7639 30.9839 93.9555 30.3547 92.9221 30.6289C92.0715 30.8503 91.2806 31.9505 91.6602 32.8504C92.655 35.2159 92.7464 38.1017 93.0662 40.6149C93.5232 44.1721 93.9133 47.7363 94.4722 51.2829C94.9081 54.0949 95.3826 57.1248 97.0592 59.5185C98.5847 61.6907 100.623 62.1617 103.161 62.0141C105.819 61.863 108.476 61.6626 111.133 61.515C116.566 61.1313 122.018 61.0867 127.457 61.3814C133.137 61.7446 138.821 62.0036 144.508 62.1582C155.812 62.4711 167.12 62.4043 178.42 62.1582C184.747 62.0223 191.081 61.8395 197.422 61.6099C199.848 61.522 202.319 61.5642 204.73 61.2584C205.602 61.1529 206.487 61.0334 207.349 60.9631C207.77 60.9315 208.189 60.9104 208.614 60.9034C208.769 60.9034 208.93 60.9034 209.085 60.921C208.832 60.8999 209.338 61.1635 208.899 60.8753C210.677 62.0528 212.8 59.3357 211.191 57.9051C206.393 53.6379 204.646 47.318 202.927 41.3601C202.066 38.3829 201.479 34.2739 198.421 32.7273C195.609 31.2932 191.848 31.9083 188.768 31.6939C182.963 31.3533 177.269 29.9548 171.967 27.5673C166.877 25.2018 162.248 21.9856 157.745 18.6674C153.113 15.2544 148.606 11.6902 143.921 8.33691C139 4.78678 133.524 1.70415 127.481 0.58287C123.766 -0.120125 119.878 0.00289924 116.11 0.154043C112.919 0.280582 109.678 0.67426 106.652 1.74633C102.767 3.08178 99.4065 5.6144 97.0522 8.98015C93.6778 13.873 92.5636 20.0523 92.2297 25.8731C92.1453 27.3881 94.4898 27.3775 94.5882 25.8731V25.8556Z"
              fill="#232323"
          />
          <path
              d="M211.539 31.7185C218.484 29.8907 225.771 27.9751 232.101 24.4952C233.465 23.743 232.53 21.3318 231.015 21.9152C224.316 24.5445 217.911 27.6376 210.938 29.5322C209.532 29.9153 210.126 32.0911 211.539 31.7185V31.7185Z"
              fill="#232323"
          />
          <path
              d="M207.813 42.7837C213.085 41.9576 218.21 40.9242 223.279 39.1632C225.739 38.3021 228.175 37.3284 230.548 36.2388C231.708 35.708 232.853 35.1351 234.038 34.6535C235.222 34.172 236.411 33.8837 237.578 33.4373C239.012 32.8855 238.959 30.4883 237.191 30.5656C234.755 30.6746 232.421 31.9224 230.256 32.9558C227.795 34.1333 225.289 35.2546 222.727 36.2247C217.742 38.1017 212.491 39.7186 207.229 40.5974C205.788 40.8364 206.407 43.0051 207.83 42.7837H207.813Z"
              fill="#232323"
          />
          <path
              d="M219.522 46.6712C222.681 46.1313 225.795 45.3594 228.84 44.3619C231.814 43.3777 234.84 41.4937 238.063 41.9717C239.937 42.2494 240.658 39.8065 238.851 39.1175C235.571 37.8697 232.035 40.1017 229.086 41.3214C225.798 42.6779 222.395 43.7367 218.917 44.4849C217.476 44.7977 218.105 46.9173 219.522 46.6712V46.6712Z"
              fill="#232323"
          />
          <path
              d="M215.81 54.0316L222.562 53.0861C224.197 52.8576 223.518 50.3268 221.859 50.5869L215.138 51.6414C213.557 51.891 214.246 54.253 215.799 54.0351L215.81 54.0316Z"
              fill="#232323"
          />
          <path
              d="M232.914 51.0685L233.413 50.8189C233.743 50.6316 233.983 50.3193 234.079 49.9527C234.175 49.5861 234.119 49.1963 233.923 48.8716C233.733 48.5533 233.429 48.3195 233.072 48.2178C232.702 48.131 232.312 48.1822 231.976 48.3619L231.477 48.6115C231.147 48.7988 230.907 49.1111 230.811 49.4777C230.715 49.8443 230.772 50.2341 230.967 50.5588C231.155 50.8791 231.46 51.1136 231.818 51.2126C232.189 51.2994 232.578 51.2482 232.914 51.0685V51.0685Z"
              fill="#232323"
          />
          <path
              d="M104.551 21.4935C111.894 14.5268 123.704 18.1121 131.679 21.845C141.212 26.309 149.648 32.8047 159.342 36.9594C164.773 39.2863 170.59 41.0192 176.566 40.7731C178.281 40.7028 178.288 38.1685 176.566 38.1017C165.233 37.6623 155.536 32.2774 145.985 26.6675C137.1 21.4478 127.49 15.6164 116.917 15.1454C111.799 14.9134 106.568 16.1261 102.744 19.6832C101.539 20.808 103.356 22.6253 104.551 21.4935V21.4935Z"
              fill="#232323"
          />
          <path
              d="M188.538 43.3847C190.517 43.3847 190.52 40.3091 188.538 40.3091C186.555 40.3091 186.555 43.3847 188.538 43.3847Z"
              fill="#232323"
          />
          <path
              d="M110.55 31.5463C115.281 30.1403 120.104 31.3916 124.61 32.9769C129.401 34.657 134.122 36.5516 138.867 38.3548C148.118 41.8698 157.429 45.9964 167.236 47.6835C172.375 48.5658 178.133 48.9911 183.124 47.1774C184.569 46.6537 183.978 44.7169 182.502 44.9173C177.581 45.6202 172.878 45.9296 167.946 45.1141C163.11 44.3162 158.407 42.854 153.791 41.2476C144.224 37.8908 134.811 34.0946 125.211 30.8117C120.318 29.135 115.056 27.9364 109.97 29.4971C108.659 29.8978 109.215 31.9575 110.54 31.5603L110.55 31.5463Z"
              fill="#232323"
          />
          <path
              d="M116.654 46.7591C125.279 47.2161 132.851 52.2073 141.392 53.188C143.016 53.3743 142.981 50.8611 141.392 50.6537C132.889 49.5535 125.304 44.7907 116.654 44.4182C115.146 44.3514 115.153 46.6818 116.654 46.7591V46.7591Z"
              fill="#232323"
          />
          <path
              d="M181.62 55.5185C183.304 55.167 184.984 54.8506 186.636 54.3901C188.288 53.9297 187.578 51.5782 185.933 51.8523C184.288 52.1265 182.583 52.5553 180.917 52.9806C179.251 53.406 179.968 55.8559 181.62 55.5185Z"
              fill="#232323"
          />
          <path
              d="M76.5681 14.4319C64.5575 10.8009 55.8298 21.7325 48.0406 28.8433C40.0363 36.1342 30.5507 41.609 20.2336 44.8927C14.3144 46.7802 8.19129 47.8171 2.0436 48.615C0.286114 48.84 0.170119 51.427 2.0436 51.427C12.7116 51.3954 23.4674 47.912 32.8875 43.0754C37.6598 40.6184 42.1684 37.6799 46.3428 34.3056C50.7577 30.7484 54.466 26.4812 58.691 22.7237C63.2956 18.6288 69.5874 14.9908 75.9495 16.6428C77.3977 17.0154 77.9952 14.8396 76.5681 14.4073V14.4319Z"
              fill="#232323"
          />
          <path
              d="M24.8133 55.529C33.2281 54.9033 40.8767 51.4129 48.3003 47.6343C52.1 45.7011 55.8716 43.7011 59.7732 41.9752C63.2566 40.4322 67.6854 38.6536 71.2672 40.8469C72.8419 41.81 74.2268 39.3882 72.7048 38.3864C69.1898 36.0806 64.7926 36.8609 61.1054 38.3126C57.0632 39.9014 53.2143 41.9998 49.3759 44.028C41.643 48.1124 33.6675 52.4288 24.8203 53.3075C23.4143 53.4481 23.3827 55.6344 24.8203 55.5255L24.8133 55.529Z"
              fill="#232323"
          />
          <path
              d="M80.9824 40.1474C82.6942 40.1474 82.6977 37.4901 80.9824 37.4901C79.2671 37.4901 79.2706 40.1474 80.9824 40.1474Z"
              fill="#232323"
          />
          <path
              d="M63.2715 54.7838C66.8183 54.1811 70.4194 53.9595 74.0133 54.123C75.7708 54.1897 75.7708 51.4832 74.0133 51.3918C70.1869 51.2251 66.3556 51.5799 62.6248 52.4463C61.0852 52.7978 61.7531 55.065 63.2715 54.7908V54.7838Z"
              fill="#232323"
          />
        </svg>
      </div>
      <div class="lecture-group-4">
        <h1 class="lecture-title">লেকচার এন্ড নোট্‌স</h1>
        <p class="lecture-content">জব সার্কুলার, রুটিন  পিডিএদ, লেকচার এন্ড নোটস সব কিছু এক সাথে</p>
        <div class="lecture-notes-page">
          <a class="lecture-notes-all" style="cursor: pointer;" > সবগুলো দেখুন</a>
          <svg
              class="lecture-arrow"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M13.2673 4.20926C12.9674 3.92357 12.4926 3.93511 12.2069 4.23504C11.9213 4.53497 11.9328 5.0097 12.2327 5.29539L18.4841 11.25H3.75C3.33579 11.25 3 11.5858 3 12C3 12.4142 3.33579 12.75 3.75 12.75H18.4842L12.2327 18.7047C11.9328 18.9904 11.9213 19.4651 12.2069 19.7651C12.4926 20.065 12.9674 20.0765 13.2673 19.7908L20.6862 12.7241C20.8551 12.5632 20.9551 12.358 20.9861 12.1446C20.9952 12.0978 21 12.0495 21 12C21 11.9504 20.9952 11.902 20.986 11.8551C20.955 11.6419 20.855 11.4368 20.6862 11.276L13.2673 4.20926Z"
                fill="#0095FF"
            />
          </svg>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {defineComponent} from "vue";
import store from "@/store";
import { URLs} from "@/static";
import {useRouter} from "vue-router";
export default defineComponent({
  setup() {
    const router = useRouter();
    const lectureNotes = () => {
      store.dispatch("setTitleBar", "লেকচার এন্ড নোট্‌স")
      router.push({
        name: URLs.ROUTE_LECTURE_NOTES_NAME,
      })
    }
    return {
      lectureNotes
    }
  }
})
</script>
<style scoped>
.lecture-notes-box {
  background: #ffffff;
  border-radius: 16px;
  border-style: solid;
  border-color: #e6e4e4;
  border-width: 1px;
  opacity: 0.9599999785423279;
  height: 180px;
  position: relative;
//display: grid;
//grid-template-columns: repeat(2, 1fr);
}

.lecture-notes-all {
  text-align: center;
  font: 600 16px/20px "Noto Sans Bengali", sans-serif;
  position: relative;
  /* left: 567px; */
  /* top: 129.31px; */
}
.lecture-arrow {
  cursor: pointer;
}

.lecture-notes-page {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: center;
  grid-gap: 12px;
  align-items: center;
}

.lecture-group {
  height: 180px;
  position: relative;
  display: grid;
  grid-template-columns: 3fr;
  justify-content: center;
  align-items: center;
}

.lecture-title {
  color: #000000;
  text-align: center;
  font: 600 20px/20px "Noto Sans Bengali", sans-serif;
  position: relative;
  /* left: 543px; */
  /* top: 40px; */
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.lecture-content {
  color: #999999;
  text-align: center;
  font: 600 16px/20px "Noto Sans", sans-serif;
  position: relative;
  /* left: 404px; */
  /* top: 74.31px; */
}
.lecture-group-2 {
  inset: 0;
  visibility: hidden;
}
.lecture-path {
  position: absolute;
  left: 180.86px;
  top: 89.06px;
  overflow: visible;
}
.lecture-path-2 {
  position: absolute;
  left: 179.16px;
  top: 87.3px;
  overflow: visible;
}
.lecture-path-3 {
  position: absolute;
  left: 156.18px;
  top: 53.26px;
  overflow: visible;
}
.lecture-path-4 {
  position: absolute;
  left: 155.01px;
  top: 51.58px;
  overflow: visible;
}
.lecture-path-5 {
  position: absolute;
  left: 75.73px;
  top: 62.95px;
  overflow: visible;
}
.lecture-path-6 {
  position: absolute;
  left: 74px;
  top: 61.3px;
  overflow: visible;
}
.lecture-path-7 {
  position: absolute;
  left: 195.18px;
  top: 58.11px;
  overflow: visible;
}
.lecture-path-8 {
  position: absolute;
  left: 193.93px;
  top: 56.48px;
  overflow: visible;
}
.lecture-path-9 {
  position: absolute;
  left: 199.64px;
  top: 51.44px;
  overflow: visible;
}
.lecture-path-10 {
  position: absolute;
  left: 198.49px;
  top: 50px;
  overflow: visible;
}
.lecture-path-11 {
  position: absolute;
  left: 189.39px;
  top: 65.5px;
  overflow: visible;
}
.lecture-group-3 {
  position: absolute;
  left: 96.68px;
  top: 64.04px;
  overflow: visible;
}
.lecture-group-4 {

}

@media (min-width: 768px) {
  .lecture-group {
    grid-template-columns: 1fr 3fr;
  }
  .lecture-group-2 {
    visibility: visible;
  }
}

</style>